export let API_ROOT;

if (process.env.REACT_APP_ENV === 'production') {
  API_ROOT = 'https://services.inplayer.com';
} else if (process.env.REACT_APP_ENV === 'staging') {
  API_ROOT = 'https://staging-v2.inplayer.com';
} else {
  API_ROOT = 'http://localhost';
}
